<template>
	<div>
		<breadcrumb :routerList="[{to:'/',title:'特价审批'}]"/>
		<div class="h-content">
			<div class="h-row h-mrt0">
				<div class="h-rowIn">
					<div class="h-rowBox">
						<div class="h-rowCon">
							<div class="h-pieceIn2">
								<div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
									<h1>基本信息</h1>
								</div>
								<div class="h-pieceCon2" style="width:100%;padding:10px;background:#fcfcfc;">
									<div class="h-formLine pricePass">
										<el-form :model="shangbuneirong" label-position="right" ref="formLabelAlign" :inline="true"  class="demo-ruleForm h-formbLine">
											<el-form-item label="项目名称" class="h-elformWrap-2" prop="formCon4">
												<el-input v-model="shangbuneirong.xiangmumingcheng" placeholder="齐鲁医院" disabled="disabled"></el-input>
											</el-form-item>
											<el-form-item label="产品型号" class="h-elformWrap-2" prop="formCon5">
												<el-input v-model="shangbuneirong.chanpinxinghao" placeholder="XM9874755TY" disabled="disabled"></el-input>
											</el-form-item>
											<el-form-item label="特价方式" class="h-elformWrap-2" prop="tejiafangshi">
												<el-select v-model="shangbuneirong.tejiafangshi" placeholder="请选择" :disabled="!chongxintijiaoshow">
													<el-option v-for="item in tejiafangshiOptions" :key="item.value"
														:label="item.label" :value="item.value">
													</el-option>
												</el-select>
											</el-form-item>
											<el-form-item label="特价折扣/金额" class="h-elformWrap-2" prop="tejiazhekoujine">
												<el-input v-model="shangbuneirong.tejiazhekoujine" placeholder="整数/小数" :disabled="!chongxintijiaoshow"  type="number"></el-input>
											</el-form-item>
											<el-form-item label="指定有效期" class="h-elformWrap-2" prop="youxiaoqi" 
												:rules="[{ required: true, message: '请指定有效期', trigger: 'blur'},]">
												<el-date-picker type="date" value-format="yyyy-MM-dd"  :clearable="false" placeholder="选择时间" v-model="shangbuneirong.youxiaoqi" :picker-options="pickerOptions"></el-date-picker>
											</el-form-item>
										</el-form>
									</div>
								</div>
							</div>
							<div class="h-pieceIn2">
								<div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
									<h1>资料展示</h1>
								</div>
								<el-form label-position="right" ref="formLabelAlign2" :inline="true"
									class="demo-ruleForm h-formbLine" style="padding-top:0rem">
								<el-form-item label="证明资料" class="h-elformWrap-1" prop="upload">
									<brupload
										:refid = "zancuntijiao"
										:reftype = "zhengmingziliao"
									>
									</brupload>
								</el-form-item>
								</el-form>
							</div>
<!--							<div class="h-pieceIn2">-->
<!--								<div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">-->
<!--									<h1>审批历史</h1>-->
<!--								</div>-->
<!--								<div class="h-pieceCon2" style="width:100%;padding:20px 50px;background:#fcfcfc;height:220px;border-radius:10px;border:1px solid #ccc;position:relative">-->
<!--                                    <div class="stepBox">-->
<!--                                        <div class="step" v-for="(item,index) in list" :key="index">-->
<!--                                            <div v-if="item.isactive==1" class="leftstep" style="border-color:#f90214;color:#f90214;">{{item.title}}-->
<!--                                                <div class="times">-->
<!--                                                    <span>{{item.time}}</span>-->
<!--                                                    <span style="margin-top:10px;">未通过审批</span>-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                            <div v-if="item.isactive==0" class="leftstep">{{item.title}}-->
<!--                                                <div class="times">-->
<!--                                                    <span>{{item.time}}</span>-->
<!--                                                    <span style="margin-top:10px;">通过审批</span>-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                            <div v-if="index<3" class="rightstep">-->
<!--                                                <div v-if="item.isactive==1" class="circle" style="border-color:#f90214;">-->
<!--                                                    <img src="../../../assets/images/checkerror.png" alt="" style="position: absolute;top: -10%;left: -10%;margin:0">-->
<!--                                                </div>-->
<!--                                                <div v-if="item.isactive==0" class="circle">-->
<!--                                                    <img src="../../../assets/images/checksuccess.png" alt="">-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--								</div>-->
<!--							</div>-->


							<!-- <div class="h-pieceIn2">
								<div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
									<h1>特价审批</h1>
								</div>
								<div class="h-pieceCon2" style="width:100%;padding:10px;background:#fcfcfc;border-radius:10px;border:1px solid #ccc">
									<div class="h-formLine pricePass">
										<el-form :model="tejiashenpi" label-position="right" ref="tejiashenpi" :inline="true" :rules="rules" class="demo-ruleForm h-formbLine">
											<div class="h-txtLeft h-mrt60">
											<el-form-item label="审批意见" class="h-elformWrapz-2" prop="shenheyijian">
												<el-input v-model="tejiashenpi.shenheyijian" placeholder="审批意见" :disabled="chongxintijiaoshow"></el-input>
											</el-form-item>
											<br>
											</div>
										</el-form>
									</div>
								</div>
							</div> -->
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="h-table h-mrt30    bbbb">
			<div class="h-pieceTitle2 hang">
				<h1 class="h1" style="margin-left:20px">审批意见</h1>
				<el-form :model="tejiashenpi" label-position="right" :inline="true"
							class="demo-ruleForm h-formbLine " ref="tejiashenpi">
					<el-form-item label="审批意见" class="h-elformWrap-2 " prop="shenheyijian" required="true"
								style="margin:30px 0 20px 23px" :rules="[{ required: true, message: '请填写审批意见', trigger: 'blur'},]">
							<el-input v-model="tejiashenpi.shenheyijian" placeholder="请输入"
									  :disabled="chongxintijiaoshow" ></el-input>
					</el-form-item>
				</el-form>
			</div>
		</div>
        <div class="anniu">
            <el-row>
					<el-button class="cancel h-btn h-bBtn h-bgwhite" @click="quxiaoanniu" >返回</el-button>
					<el-button class=" el-button h-btn h-bBtn h-bgred el-button--default" @click="bohuianniu" v-if="!chongxintijiaoshow&&taskstatus==0">驳回</el-button>
					<el-button class=" el-button h-btn h-bBtn h-bggreen el-button--default" @click="tongguoanniu" v-if="!chongxintijiaoshow&&taskstatus==0">通过</el-button>
					<!-- <el-button class="h-btn h-bBtn h-bgblue2"   @click="chongxintijiao" v-if="chongxintijiaoshow&&taskstatus==0">重新提交</el-button> -->
					<el-button class=" h-btn h-bBtn" id="queren" @click="chakanjindu()">查看进度</el-button>
            </el-row>
        </div>

		<viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>

<!--		<div id="cat">-->

<!--        <el-dialog :visible.sync="dialogFormVisible2" class="h-dialog2">-->

<!--            <div class="h-dialogImgwl">-->
<!--                <div class="h-disTable">-->
<!--                    <div class="h-tableCell">-->
<!--                        <h1>提示信息</h1>-->
<!--                        <p v-if="tishixinxi">{{tishixinxi}}</p>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->

<!--        </el-dialog>-->

<!--		</div>-->

	</div>
</template>
<script>
	import ss from '../../../api/SystemService'
const cityOptions = [1,2,3,4,5,6,7,8];
export default {
	data(){
      return{


			pickerOptions: {
				disabledDate(time) {
					return time.getTime() < Date.now();
				},
			},
		  	taskstatus:'',
				//特价产品
			specialOfferDetail:{},
			chongxintijiaoshow:false,
			instid:'',
			showhistory:false,
      	//是否已提交过通过驳回
      	shifouyitijiaotongguobohui:false,
      	//通过还是驳回
		  	tonguoorbohui:1,
			//初始获取的审批流的参数
			chushihuoqu:{

			},
			tejiafangshiOptions: [
				{
					value:1,
					label:'金额',
				},
				{
					value:2,
					label:'折扣',
				},
			],

			//弹框
			dialogFormVisible2:false,
			//特价版本id
			idmsg:'201910155a9b6d00',
			//审批提示信息
			tishixinxi:'',
			//通过返回特价版本信息
			offer:{},

			//通过返回特价版本产品
			offde:[],
			tejiashenpi:{
				shenheyijian:'',

			},
      	  //特价版本id
      	zancuntijiao:'',
		  //资料名字
			zhengmingziliao:'zhengmingziliao',
			shangbuneirong:{
					xiangmumingcheng:'',
					chanpinxinghao:'',
					tejiafangshi:'',
					tejiazhekoujine:'',
					youxiaoqi:'',
			},
			list:[
				{
					title:'型号部门',
					isactive:0,
					time:'2019/09/10 18:00:00',
				},
				{
					title:'采购经理',
					isactive:0,
					time:'2019/09/10 18:00:00',
				},
				{
					title:'小微主',
					isactive:0,
					time:'2019/09/10 18:00:00',
				},
				{
					title:'财务经理',
					isactive:0,
					time:'2019/09/10 18:00:00',
				}],
		  //带线表单
			formLabelAlign: {
				formCon4: '',
				formCon5: '',
				formCon6:'',
				formCon7:'',
		   },
			multipleSelection: [],
			tableData2: [{
				reporter: 'HU87889976432',
				visitTime:'XM8765444324',
				num:'12',
				price:'268,000元',
				grade:'268,000元'
				},{
				reporter: 'HU87889976432',
				visitTime:'XM8765444324',
				num:'12',
				price:'268,000元',
				grade:'268,000元'
				},{
				reporter: 'HU87889976432',
				visitTime:'XM8765444324',
				num:'12',
				price:'268,000元',
				grade:'268,000元'
				},{
				reporter: 'HU87889976432',
				visitTime:'XM8765444324',
				num:'12',
				price:'268,000元',
				grade:'268,000元'
				},{
				reporter: 'HU87889976432',
				visitTime:'XM8765444324',
				num:'12',
				price:'268,000元',
				grade:'268,000元'
				}],
        }
    },
	//加载页面默认执行
	created() {
		this.instid = this.$router.history.current.query.instid;
		this.chushihuoqu = this.$router.history.current.query;
		this.taskstatus = this.$route.query.taskstatus;
		console.log(this.$router.history.current.query,'asdasd???asd')
		//默认首次取数
		this.gettableels();
	},
	//监视器
	watch:{
		shifouyitijiaotongguobohui(val){
			if(val){
				//返回首页
				this.$router.push({ path: '/firstPage' , query: {id: ''}});
			}
		}
	},
    methods:{
		//重新提交
		chongxintijiao(){
			var canshuin = {
				id:this.specialOfferDetail.id,
				tejiafangshi:this.shangbuneirong.tejiafangshi,
			}
			if(this.shangbuneirong.tejiafangshi==1){//金额
				canshuin.proDiscPrice = this.shangbuneirong.tejiazhekoujine;
			}else if(this.shangbuneirong.tejiafangshi==2){//折扣
				canshuin.proDiscount = this.shangbuneirong.tejiazhekoujine;
			}
			//先更新
			ss.specialController.gengxintejia(canshuin).then(rd => {
				//成功通过
				if(rd.f==true){
					this.tongguoanniu();
				}
			})
		},
		//查看进度
		chakanjindu(){
			this.showhistory = true;
		},
		gettheloginuser(){
			this._user.usercode;
		},
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
		gettableels(){
			//拿到id
			this.idmsg = this.chushihuoqu.ywid;
			var id ={
				id: this.idmsg,
			}
			this.zancuntijiao = this.idmsg;
			//取页面参数
			ss.specialController.tejiaxiangqing(id).then(rd => {
				this.shangbuneirong.xiangmumingcheng = rd.prname;
				this.shangbuneirong.chanpinxinghao = rd.chanpinxinghao;
				this.shangbuneirong.tejiafangshi = parseInt(rd.tejiafangshi)||'';
				this.shangbuneirong.tejiazhekoujine = rd.tejiafangshi=='1'?rd.chanpinzhekoujine:rd.tejiafangshi=='2'?rd.zhekou:'';
				//特价产品
				this.specialOfferDetail = rd.specialOfferDetail;
				//特价
				this.offer = rd.offer;
				//如果是驳回单
				if(rd.offer.bohui==1){
					this.chongxintijiaoshow = true;
					this.tejiashenpi.shenheyijian = rd.offer.shenpijindu.split("_")[2]||'';
				}
			})
		},
        //通过按钮
		tongguoanniu(){
			if(this.shangbuneirong.youxiaoqi!=''&&this.shangbuneirong.youxiaoqi!=null){
				this.tonguoorbohui = 2;
				this.tijiaogengxinzhuangtai();
			}else{
				this.$msg.msge("请先选择有效期")
			}
		},
		//提交更新审核状态
		tijiaogengxinzhuangtai(){
			console.log('chushihuoqu',this.chushihuoqu)
			var sid = {
				sid:this.idmsg,
				taskid:this.chushihuoqu.taskid,
				optflag:this.tonguoorbohui==1?'驳回':'通过',
				msg:this.tejiashenpi.shenheyijian,
				tongguoorbohui:this.tonguoorbohui,//通过还是驳回 1驳回  2通过
				youxiaoqi:this.shangbuneirong.youxiaoqi,//有效期
			}
			ss.specialController.tongguoshenhe(sid).then(rd => {
				if(rd.f==true&&this.tonguoorbohui==2){
					this.$msg.alerts("提交成功！",()=>{
						//刷新右上角的代办个数
						this.$store.dispatch("searchTasktotal")
						//跳转回系统的代办列表
						this.$router.push({path:'/personal/dealCenter'})
					})
				}
				if(rd.f){
					this.offer = rd.off;
					this.offde = rd.od;
				}
				this.tishixinxi = rd.msg;
				this.$msg.msgs(rd.msg)
				this.dialogFormVisible2 = true;
				this.shifouyitijiaotongguobohui = true;
			})
		},
        //驳回按钮
		bohuianniu(){
			this.tonguoorbohui = 1;
			this.$refs['tejiashenpi'].validate((valid) => {
				if (valid) {
					this.tijiaogengxinzhuangtai();
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
        //取消按钮
		quxiaoanniu(){
            //返回首页
            this.$router.push({ path: '/firstPage'});
		},
   },
}
</script>

<style scoped>
.cancel {
        padding: 0.18rem 0.42rem;
}
.pricePass{
    margin-top: 0.38rem;
}
#queren {
		background-color: #006aca;
		color: white;
	}
</style>
<style>
.pricePass .h-formbLine .el-form-item__label{
    width: 34%;
    text-align: right;
}
.pricePass .h-formbLine .el-form-item__content{
    width: 66%;
}
.pricePass .h-formbLine .h-elformWrap-2{
    width: 33.333%;
    padding-right: 0.5rem
}
.pricePass .h-formbLine .h-elformWrap-1{
    width: 100%;
    padding-right: 0.5rem
}
.pricePass .h-formbLine .h-elformWrap-1 .el-form-item__label{
    width: 9.7%;
}
.pricePass .h-formbLine .h-elformWrap-1 .el-form-item__content{
    width: 90.3%;
}
.anniu {
    margin-left: 6rem;
    margin-top: 30px;
}
.bbbb {
	padding-top: 5px;
	margin: 10px 20px 0 20px;
}
.hang {
	padding: 20px 0;
	margin-bottom: 0;
	background-color: white;
}
</style>